<div class="upload-container" *ngIf="isMobileDevice">
    <div class="upload-step">
        <ng-container *ngTemplateOutlet="header"></ng-container>

        <ng-container *ngIf="!step && !showError">
            <h2>Upload Service Documents</h2>
            <ul class="service-documents__list">
                <ng-container *ngFor="let doc of claim_docs; let index = index">

                    <li class="service-documents__item">
                        <span>{{doc.document_type_short_name}}
                            <span class="optional d-block" [class.requried]="doc.is_required"
                                *ngIf="!doc.is_uploaded">{{doc.is_required ? '(Required)':'(Recommended)'}}</span>
                        </span>

                        <div class="service-documents__upload">
                            <img src="assets/img/svg/upload-icon.svg" alt="Upload Icon"
                                *ngIf="!doc.is_uploading && !doc.is_uploaded" (click)="selectedIndex = index; step = 1">
                            <ng-container *ngIf="doc.is_uploaded">
                                <div class="d-flex align-items-center">
                                    <a [href]="doc.doc_file" target="_blank" class="fileName">
                                        <svg class="mt-1 me-2" width="30" height="30" viewBox="0 0 30 30" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="30" height="30" rx="15" fill="#FAFAFA" />
                                            <path
                                                d="M13.1667 15C13.1667 15.4862 13.3598 15.9525 13.7036 16.2964C14.0475 16.6402 14.5138 16.8333 15 16.8333C15.4862 16.8333 15.9525 16.6402 16.2964 16.2964C16.6402 15.9525 16.8333 15.4862 16.8333 15C16.8333 14.5138 16.6402 14.0475 16.2964 13.7036C15.9525 13.3598 15.4862 13.1667 15 13.1667C14.5138 13.1667 14.0475 13.3598 13.7036 13.7036C13.3598 14.0475 13.1667 14.5138 13.1667 15Z"
                                                stroke="#797F87" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M23.25 15C21.05 18.6667 18.3 20.5 15 20.5C11.7 20.5 8.95 18.6667 6.75 15C8.95 11.3333 11.7 9.5 15 9.5C18.3 9.5 21.05 11.3333 23.25 15Z"
                                                stroke="#797F87" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </a>

                                    <svg style="cursor: pointer;" (click)="remoeveFile(index)" width="30" height="30"
                                        viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="30" height="30" rx="15" fill="#FFF4F4" />
                                        <path d="M11.4609 18.5379L18.5359 11.4629" stroke="#D50000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M18.5359 18.5379L11.4609 11.4629" stroke="#D50000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </ng-container>
                        </div>
                        <div class="service-documents__upload" *ngIf="doc.is_uploading">
                        </div>
                    </li>

                    <a href="javascript:void(0)" class="text__link add-more"
                        *ngIf="doc.can_be_multiple == 1 && claim_docs.length == index+1 && !disable_more && clamisData && clamisData.temp_claim_id"
                        (click)="copyObject(doc)">+ Add more</a>
                    <!-- <a href="javascript:void(0)" class="text__link remove" *ngIf="(disable_more && index == claim_docs.length-1)" (click)="deleteObject(index)">Remove</a> -->
                </ng-container>

            </ul>
            <button class="submit-btn"
                (click)="(needMoreDoc && needMoreDoc.claimId) ? uploadDocForNeedMore() : uploadDoc()"
                [disabled]="isDisabld">Submit Document</button>
        </ng-container>

        <ng-container *ngIf="step == 1">
            <div class="upload--wrapper">
                <div class="upload--content">
                    <img src="/assets/img/svg/file_icon.svg" alt="">
                    <h3 *ngIf="claim_docs && claim_docs.length">{{claim_docs[selectedIndex].document_type_short_name}}</h3>
                    <p>Make sure your document is Clear <br>and legible.</p>
                </div>
                <div class="button--wrapper">
                    <div class="upload--btn upload--camera mt-0">
                        <input capture="camera" type="file" class="service-documents__input"
                            [id]="'uploadc' + selectedIndex " [accept]="fileType"
                            (change)="checkClaimStatus(selectedIndex, $event.target.files)" />
                        <label [for]="'uploadc' + selectedIndex" class="service-documents__upload-btn mb-0">
                            Camera
                        </label>
                    </div>
                    <div class="upload--btn">
                        <input type="file" class="service-documents__input" [id]="'upload' + selectedIndex "
                            [accept]="fileType" (change)="checkClaimStatus(selectedIndex, $event.target.files)" />
                        <label [for]="'upload' + selectedIndex" class="service-documents__upload-btn mb-0">
                            Upload From Gallery
                        </label>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="step == 2">
            <ng-container *ngTemplateOutlet="thankYouScreen"></ng-container>
        </ng-container>

        <ng-container *ngIf="showError">
            <ng-container *ngTemplateOutlet="error"></ng-container>
        </ng-container>

    </div>


</div>


<div class="upload-container" *ngIf="!isMobileDevice">
    <div class="upload-step">
        
        <ng-container *ngTemplateOutlet="header"></ng-container>

        <section class="upload-section" *ngIf="!showError && step != 2 && needMoreDoc">
            <div class="upload-section-left">
                <p>We've reviewed your claim for <b translate="no">{{needMoreDoc.name}} (ID: {{needMoreDoc.contract_code}})</b> and require additional documentation to approve the <b translate="no">{{needMoreDoc.amount | currency}}</b> claim.</p>
                <h2>Upload Service Documents</h2>
            <ul class="service-documents__list">
                <ng-container *ngFor="let doc of claim_docs; let index = index">

                    <li class="service-documents__item">
                        <span>{{doc.document_type_short_name}}
                            <small class="d-block" *ngIf="doc.reason">
                                Note: {{doc.reason}}
                            </small>
                            
                        </span>

                        <div class="service-documents__upload">
                            <ng-container *ngIf="!doc.is_uploaded">
                                <input type="file" class="service-documents__input" [id]="'upload_' + index "
                                [accept]="fileType" (change)="checkClaimStatus(index, $event.target.files)" />
                                    <label [for]="'upload_' + index" class="service-documents__upload-btn mb-0">
                                        <img src="assets/img/svg/upload-icon.svg" alt="Upload Icon" *ngIf="!doc.is_uploading && !doc.is_uploaded" >
                                    </label>
                            </ng-container>
                                <!-- <span class="optional d-block" [class.requried]="doc.is_required"
                            *ngIf="!doc.is_uploaded">{{doc.is_required ? '(Required)':'(Recommended)'}}</span> -->
                            <ng-container *ngIf="doc.is_uploaded">
                                <div class="d-flex align-items-center">
                                    <a [href]="doc.doc_file" target="_blank" class="fileName">
                                        <svg class="mt-1 me-2" width="30" height="30" viewBox="0 0 30 30" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="30" height="30" rx="15" fill="#FAFAFA" />
                                            <path
                                                d="M13.1667 15C13.1667 15.4862 13.3598 15.9525 13.7036 16.2964C14.0475 16.6402 14.5138 16.8333 15 16.8333C15.4862 16.8333 15.9525 16.6402 16.2964 16.2964C16.6402 15.9525 16.8333 15.4862 16.8333 15C16.8333 14.5138 16.6402 14.0475 16.2964 13.7036C15.9525 13.3598 15.4862 13.1667 15 13.1667C14.5138 13.1667 14.0475 13.3598 13.7036 13.7036C13.3598 14.0475 13.1667 14.5138 13.1667 15Z"
                                                stroke="#797F87" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M23.25 15C21.05 18.6667 18.3 20.5 15 20.5C11.7 20.5 8.95 18.6667 6.75 15C8.95 11.3333 11.7 9.5 15 9.5C18.3 9.5 21.05 11.3333 23.25 15Z"
                                                stroke="#797F87" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </a>

                                    <svg style="cursor: pointer;" (click)="remoeveFile(index)" width="30" height="30"
                                        viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="30" height="30" rx="15" fill="#FFF4F4" />
                                        <path d="M11.4609 18.5379L18.5359 11.4629" stroke="#D50000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M18.5359 18.5379L11.4609 11.4629" stroke="#D50000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </ng-container>
                        </div>
                        <div class="service-documents__upload" *ngIf="doc.is_uploading">
                        </div>
                    </li>

                    <a href="javascript:void(0)" class="text__link add-more"
                        *ngIf="doc.can_be_multiple == 1 && claim_docs.length == index+1 && !disable_more && clamisData && clamisData.temp_claim_id"
                        (click)="copyObject(doc)">+ Add more</a>
                    <!-- <a href="javascript:void(0)" class="text__link remove" *ngIf="(disable_more && index == claim_docs.length-1)" (click)="deleteObject(index)">Remove</a> -->
                </ng-container>

            </ul>
            <button class="submit-btn" style="width:auto;"
                (click)="(needMoreDoc && needMoreDoc.claimId) ? uploadDocForNeedMore() : uploadDoc()"
                [disabled]="isDisabld">Submit Document</button>
            </div>
            <div class="upload-section-right">
                <div class="scan--box">
                    <img [src]="qrData && qrData.img" alt="">
                    <b class="d-blck">Scan to upload documents</b>
                    <i>You can access your camera. We will send you a secure link for continuing on your phone.</i>
                </div>
            </div>
        </section>

        <ng-container *ngIf="showError"> 
            <ng-container *ngTemplateOutlet="error"></ng-container>
        </ng-container>
        
        <ng-container *ngIf="step == 2">
            <ng-container *ngTemplateOutlet="thankYouScreen"></ng-container>
        </ng-container>
    </div>
</div>



<ng-template #error>
    <div class="error-wrapper">
        <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="24.5" cy="57.5" rx="18.5" ry="3.5" fill="black" fill-opacity="0.15" />
            <path
                d="M46.75 9.18519C50.8977 11.58 54.3481 15.0166 56.7595 19.1548C59.1709 23.2929 60.4597 27.9891 60.4984 32.7784C60.5371 37.5677 59.3243 42.2841 56.9801 46.4606C54.6358 50.6372 51.2414 54.129 47.1329 56.5906C43.0244 59.0521 38.3443 60.398 33.5558 60.4949C28.7673 60.5918 24.0365 59.4364 19.8318 57.1431C15.627 54.8498 12.0941 51.4981 9.58283 47.4199C7.07152 43.3416 5.66888 38.6781 5.51375 33.8912L5.5 33.0002L5.51375 32.1092C5.66776 27.3599 7.04976 22.7316 9.52501 18.6754C12.0003 14.6193 15.4843 11.2737 19.6375 8.96487C23.7906 6.65605 28.4712 5.46278 33.2228 5.5014C37.9744 5.54001 42.6349 6.80919 46.75 9.18519ZM33.0275 41.2502L32.6783 41.2694C32.0099 41.3489 31.3938 41.6708 30.9469 42.1741C30.4999 42.6774 30.2531 43.3271 30.2531 44.0002C30.2531 44.6733 30.4999 45.323 30.9469 45.8263C31.3938 46.3296 32.0099 46.6514 32.6783 46.7309L33 46.7502L33.3492 46.7309C34.0176 46.6514 34.6337 46.3296 35.0806 45.8263C35.5276 45.323 35.7744 44.6733 35.7744 44.0002C35.7744 43.3271 35.5276 42.6774 35.0806 42.1741C34.6337 41.6708 34.0176 41.3489 33.3492 41.2694L33.0275 41.2502ZM33 19.2502C32.3264 19.2503 31.6763 19.4976 31.173 19.9452C30.6696 20.3927 30.3481 21.0095 30.2692 21.6784L30.25 22.0002V33.0002L30.2692 33.3219C30.3488 33.9903 30.6706 34.6063 31.1739 35.0533C31.6772 35.5003 32.3269 35.7471 33 35.7471C33.6731 35.7471 34.3228 35.5003 34.8261 35.0533C35.3294 34.6063 35.6512 33.9903 35.7308 33.3219L35.75 33.0002V22.0002L35.7308 21.6784C35.6519 21.0095 35.3304 20.3927 34.827 19.9452C34.3237 19.4976 33.6736 19.2503 33 19.2502Z"
                fill="url(#paint0_linear_3204_18570)" />
            <defs>
                <linearGradient id="paint0_linear_3204_18570" x1="32.9997" y1="5.50049" x2="32.9997" y2="60.5005"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#D50000" />
                    <stop offset="1" stop-color="#EC5F5F" />
                </linearGradient>
            </defs>
        </svg>

        <h2>Your document link has expired. For assistance, please contact Denefits Support.</h2>

        <a href="https://business.denefits.com/" class="text__url">Login To Dashboard</a>

    </div>
</ng-template>


<ng-template #thankYouScreen>
    <div class="thankYouScreen" >
        <div class="content">
            <img src="assets/img/svg/subitted.svg" alt="Claim Submitted Icon" class="icon">
            <h1>All the documents submitted successfully.</h1>
            <p>Go back to your dashboard to {{needMoreDoc && needMoreDoc.claimId ? 'Check Claim Status' : 'finish
                submitting your claim.'}}</p>
        </div>
    </div>
</ng-template>


<ng-template #header>
    <header class="d-flex align-items-center">
        <div class="back--btn" *ngIf="step == 1" (click)="step = 0">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.0465 33C25.8526 33 33.0576 25.8 33.0576 17C33.0576 8.19999 25.8526 1 17.0465 1C8.24039 1 1.0354 8.19999 1.0354 17C1.0354 25.8 8.24039 33 17.0465 33Z"
                    stroke="#DFE5ED" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.5828 13.459L12.0419 16.9998L15.5828 20.5407" stroke="#272D35" stroke-width="1.09091"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M21.9586 17H12.1411" stroke="#272D35" stroke-width="1.09091" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </div>
        <img src="/assets/img/svg/logo_login.svg" alt="Denefits Logo" class="logo">
    </header>
</ng-template>
